import { Feature, LineString } from 'geojson';
import PolygonLoader from '../loaders/PolygonsLoader';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';

const polygonLoader = new PolygonLoader();

export default class PolygonGenerator extends SingletonEventEmitterClass {

  private _outline: ILngLat[] = [];
  private _naviline: ILngLat[] = [];
  private _generating: boolean = false;

  private get _outlineTail() {
    if (this._outline.length === 0) {
      return null;
    }
    return this._outline[this._outline.length - 1];
  }

  public get generating() {
    return this._generating;
  }

  public get geojsonOutline(): Feature<LineString> {
    return {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: this._outline,
      },
      properties: {
        name: 'outline',
      },
    };
  }

  public get geojsonNaviline(): Feature<LineString> {
    return {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: this._naviline,
      },
      properties: {
        name: 'naviline',
      },
    };
  }

  constructor() {
    super();
    if (PolygonGenerator.__new) {
      document.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.code === 'Escape') {
          this.cancelGenerating();
        }
      });
    }
  }

  public cancelGenerating() {
    this._outline = [];
    this._naviline = [];
    this._triggerOutlineRefresh();
  }

  public onMapMouseMove(lngLat: ILngLat) {
    if (this._outlineTail) {
      this._naviline = [this._outlineTail, lngLat];
      this._triggerNavilineRefresh();
    }
  }

  public onMapClickedOriginalPoint(lngLat: ILngLat) {
    const existsPoint = this._outline.find(point => point.toString() === lngLat.toString());
    if (existsPoint) {
      if (existsPoint === this._outline[0]) {
        this._finish();
      } else {
        this._pull(existsPoint);
      }
    } else {
      this._join(lngLat);
    }
  }

  public onMapRightClickedOriginalPoint() {
    this._finish();
  }

  private _join(point: ILngLat) {
    this._outline.push(point);
    this._naviline[0] = point;
    this._triggerOutlineRefresh();
  }

  private _pull(lngLat: ILngLat) {
    this._outline.splice(this._outline.indexOf(lngLat), 1);
    this._naviline[0] = this._outlineTail!;
    this._triggerOutlineRefresh();
  }

  private _finish() {
    if (this._outline.length < 3) {
      return;
    }
    if (this._outline[0].toString() !== this._outline[this._outline.length - 1].toString()) {
      this._outline.push(this._outline[0]);
    }
    polygonLoader.addPolygon(this._outline);
    this._outline = [];
    this._naviline = [];
    this._triggerOutlineRefresh();
  }

  private _triggerOutlineRefresh() {
    this._triggerNavilineRefresh();
    this.emit('outline_updated');
  }

  private _triggerNavilineRefresh() {
    this._generating = this._naviline.length > 0;
    this.emit('naviline_updated');
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/generators/PolygonGenerator.ts